'use client';

import { API_ROUTES, useApiQuery } from '@shared/api-utils';
import { getSiteConfig } from '@shared/config';
import { useTranslations } from 'next-intl';

const ACCOUNT_REVIEW_REMINDER_HEADERS = {
  countryCode: 'GB',
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

enum Interval {
  ONE_MONTH = 'P1M',
  THREE_MONTHS = 'P3M',
  SIX_MONTHS = 'P6M',
}

type AccountReviewReminderDTO = {
  interval: Interval;
};

type AccountReviewReminderData = {
  interval: Interval;
  displayLabel: string;
  isLoading: boolean;
};

const INTERVAL_TRANSLATION_MAP: Record<Interval, string> = {
  [Interval.SIX_MONTHS]: 'account_review_reminder_sheet.options.P6M',
  [Interval.THREE_MONTHS]: 'account_review_reminder_sheet.options.P3M',
  [Interval.ONE_MONTH]: 'account_review_reminder_sheet.options.P1M',
};

const DEFAULT_INTERVAL = Interval.SIX_MONTHS;

function useAccountReviewReminderData(namespace: string): AccountReviewReminderData {
  const t = useTranslations(namespace);
  const { showsAccountReviewReminder } = getSiteConfig().MY_ACCOUNT_SETTINGS;

  const { data, isLoading } = useApiQuery<AccountReviewReminderDTO>(API_ROUTES.MY_ACCOUNT.ACCOUNT_REVIEW_REMINDER.GET, {
    credentials: true,
    headers: ACCOUNT_REVIEW_REMINDER_HEADERS,
    queryOptions: {
      enabled: showsAccountReviewReminder,
    },
  });

  const interval = data?.interval ?? DEFAULT_INTERVAL;
  const displayLabel = t(INTERVAL_TRANSLATION_MAP[interval]);

  return {
    interval,
    displayLabel,
    isLoading,
  };
}

export { ACCOUNT_REVIEW_REMINDER_HEADERS, Interval, useAccountReviewReminderData };
export type { AccountReviewReminderDTO };
